import { OfferStateTypes, OfferActionTypes } from "./Offer.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: OfferStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const OfferReducer = (
  state: OfferStateTypes = INITIAL_STATE,
  action: any
): OfferStateTypes => {
  switch (action.type) {
    case OfferActionTypes.FETCH_ALL_OFFER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case OfferActionTypes.FETCH_ALL_OFFER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case OfferActionTypes.FETCH_ALL_OFFER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case OfferActionTypes.FETCH_ALL_OFFER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case OfferActionTypes.FETCH_ONE_OFFER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case OfferActionTypes.FETCH_ONE_OFFER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case OfferActionTypes.FETCH_ONE_OFFER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case OfferActionTypes.FETCH_ONE_OFFER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default OfferReducer;
